// extracted by mini-css-extract-plugin
export default {"header":"header--2lIp6","header--discrete":"header--discrete--1EqZ8","header__section":"header__section--1r6Hx","header__separator":"header__separator--2-ECO","header__separator--ml":"header__separator--ml--3DScP","header__separator--mr":"header__separator--mr--L_Zyk"};
    if(module.hot) {
      // 1747648144201
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  